import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { Platform } from 'react-native';
import AppHeader from '../components/AppHeader';
import IntroAbout1Screen from '../screens/intro/IntroAbout1Screen';
import IntroAbout2Screen from '../screens/intro/IntroAbout2Screen';
import IntroAbout3Screen from '../screens/intro/IntroAbout3Screen';
import IntroAbout4Screen from '../screens/intro/IntroAbout4Screen';
import IntroAbout5Screen from '../screens/intro/IntroAbout5Screen';
import IntroScreen from '../screens/intro/IntroScreen';
import LoginScreen from '../screens/intro/LoginScreen';
import SignUpScreen from '../screens/intro/SignUpScreen';
import ForgotPasswordScreen from '../screens/intro/ForgotPasswordScreen';
import ResetPasswordSentScreen from '../screens/intro/ResetPasswordSentScreen';
import SignUpEmailVerificationScreen from '../screens/intro/SignUpEmailVerificationScreen';

export type IntroParamList = {
  Intro: { isLoginModalOpen?: boolean };
  IntroAbout1Screen: undefined;
  IntroAbout2Screen: undefined;
  IntroAbout3Screen: undefined;
  IntroAbout4Screen: undefined;
  IntroAbout5Screen: undefined;
  LoginScreen: undefined;
  SignUpScreen: undefined;
  ForgotPasswordScreen: undefined;
  ResetPasswordSentScreen: { email: string };
  SignUpEmailVerificationScreen: { email?: string; token?: string };
};

const IntroStack = createStackNavigator<IntroParamList>();

export default function IntroNavigator() {
  return (
    <IntroStack.Navigator
      initialRouteName='LoginScreen'
      screenOptions={{
        header: () => <AppHeader />,
        headerShown: Platform.OS === 'web',
        gestureEnabled: false
      }}
    >
      <IntroStack.Screen
        name='IntroAbout1Screen'
        component={IntroAbout1Screen}
      />
      <IntroStack.Screen
        name='IntroAbout2Screen'
        component={IntroAbout2Screen}
      />
      <IntroStack.Screen
        name='IntroAbout3Screen'
        component={IntroAbout3Screen}
      />
      <IntroStack.Screen
        name='IntroAbout4Screen'
        component={IntroAbout4Screen}
      />
      <IntroStack.Screen
        name='IntroAbout5Screen'
        component={IntroAbout5Screen}
      />
      <IntroStack.Screen name='Intro' component={IntroScreen} />
      <IntroStack.Screen
        name='LoginScreen'
        component={LoginScreen}
        options={{ title: 'LoginScreen' }}
      />
      <IntroStack.Screen name='SignUpScreen' component={SignUpScreen} />
      <IntroStack.Screen
        name='SignUpEmailVerificationScreen'
        component={SignUpEmailVerificationScreen}
      />
      <IntroStack.Screen
        name='ForgotPasswordScreen'
        component={ForgotPasswordScreen}
      />
      <IntroStack.Screen
        name='ResetPasswordSentScreen'
        component={ResetPasswordSentScreen}
      />
    </IntroStack.Navigator>
  );
}
